module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fuild ucenter"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "ucenter-sidebar cf"
  }, [_vm._t("menu")], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "ucenter-body cf"
  }, [(!!_vm.$route.meta.title) ? _c('header', {
    staticClass: "ucenter-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$route.meta.title))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view')], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-22169647!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/layout-ucenter.vue
// module id = 218
// module chunks = 29